import {IApiBusinessProfileProto, space} from "../../../compiled";
import IBusinessLocationProto = space.kenko.proto.IBusinessLocationProto;
import IServiceProto = space.kenko.proto.IServiceProto;
import {findLocation} from "../BusinessUtil";

type Props = {
  service: IServiceProto,
  businessProfile: IApiBusinessProfileProto | undefined,
  onSelect: (location: IBusinessLocationProto) => void;
}

export const ChooseLocation = (props: Props) => {

  return <div style={{display: 'flex', flexDirection: "column", textAlign: 'start'}}>
    <h3>Select Service Location</h3>

    {props.service.availableLocationIds?.map(locationId => {
      const location = findLocation(props.businessProfile, locationId);
      if (!location) {
        return
      }
      return <button key={'loc' + location.locationId} className={'BookingOverlaySelectable'} onClick={() => {props.onSelect(location)}}>
        <div><b>{location.locationName}</b></div>
        <div>{location.physicalLocation?.address}</div>
      </button>
    })}
  </div>
}